var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "courseArrangement" }, [
    _vm.currentCourse.length > 0
      ? _c("div", { staticClass: "currentCourse coursemeeting" }, [
          _c("div", { staticClass: "list-title" }, [_vm._v("当前安排")]),
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.currentCourse, function (item, index) {
              return _c("div", { key: index, staticClass: "list-item" }, [
                _c("div", { staticClass: "list-item-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "list-item-top",
                      on: {
                        click: function ($event) {
                          return _vm.signIn(item)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "list-item-title" },
                        [
                          _c("div", { staticClass: "list-item-title-text" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _c("van-icon", {
                            attrs: {
                              name: "arrow",
                              size: "0.2rem",
                              color: "#999",
                            },
                          }),
                        ],
                        1
                      ),
                      item.className
                        ? _c("div", { staticClass: "classname" }, [
                            _vm._v(_vm._s(item.className)),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "list-item-bottom" },
                    [
                      _c(
                        "van-row",
                        { attrs: { gutter: "20" } },
                        [
                          _c("van-col", { attrs: { span: "12" } }, [
                            _c("div", { staticClass: "bottomcontent" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v("上课地点"),
                              ]),
                              _c("div", { staticClass: "bottom-text" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(item.place ? item.place : "暂无") +
                                    " "
                                ),
                              ]),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "12" } }, [
                            _c("div", { staticClass: "bottomcontent" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v("上课时间"),
                              ]),
                              _c("div", { staticClass: "bottom-text" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(item.affairDate) +
                                    " " +
                                    _vm._s(item.beginTime) +
                                    "-" +
                                    _vm._s(item.endTime) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentCourse.length - 1 != index,
                      expression: "currentCourse.length - 1 != index",
                    },
                  ],
                  staticClass: "list-item-grey",
                }),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
    _c("div", { staticClass: "notOpenCourse coursemeeting" }, [
      _c("div", { staticClass: "list-title" }, [_vm._v("未开始安排")]),
      _vm.notOpenCourse.length > 0
        ? _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.notOpenCourse, function (item, index) {
              return _c("div", { key: index, staticClass: "list-item" }, [
                _c("div", { staticClass: "list-item-content" }, [
                  _c("div", { staticClass: "list-item-top" }, [
                    _c("div", { staticClass: "list-item-title" }, [
                      _c("div", { staticClass: "list-item-title-text" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                    ]),
                    item.className
                      ? _c("div", { staticClass: "classname" }, [
                          _vm._v(_vm._s(item.className)),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "list-item-bottom" },
                    [
                      _c(
                        "van-row",
                        { attrs: { gutter: "20" } },
                        [
                          _c("van-col", { attrs: { span: "12" } }, [
                            _c("div", { staticClass: "bottomcontent" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v("上课地点"),
                              ]),
                              _c("div", { staticClass: "bottom-text" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(item.place ? item.place : "暂无") +
                                    " "
                                ),
                              ]),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "12" } }, [
                            _c("div", { staticClass: "bottomcontent" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v("上课时间"),
                              ]),
                              _c("div", { staticClass: "bottom-text" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(item.affairDate) +
                                    " " +
                                    _vm._s(item.beginTime) +
                                    "-" +
                                    _vm._s(item.endTime) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.notOpenCourse.length - 1 != index,
                      expression: "notOpenCourse.length - 1 != index",
                    },
                  ],
                  staticClass: "list-item-grey",
                }),
              ])
            }),
            0
          )
        : _c("div", { staticClass: "arrange-nodata" }, [
            _c("div", { staticClass: "nodatacontent" }, [
              _c("img", {
                attrs: {
                  src: require("_teas/public/img/product/bootScreen/img-null.png"),
                  alt: "",
                  srcset: "",
                },
              }),
              _c("div", { staticClass: "text" }, [_vm._v("暂无课程")]),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }